__turbopack_context__.v({
  "backBtn": "Header-module__arFiJq__backBtn",
  "backBtnMobile": "Header-module__arFiJq__backBtnMobile",
  "container": "Header-module__arFiJq__container",
  "fadeInItems": "Header-module__arFiJq__fadeInItems",
  "headerContent": "Header-module__arFiJq__headerContent",
  "link": "Header-module__arFiJq__link",
  "linkActive": "Header-module__arFiJq__linkActive",
  "links": "Header-module__arFiJq__links",
  "linksMain": "Header-module__arFiJq__linksMain",
  "linksMainVisible": "Header-module__arFiJq__linksMainVisible",
  "logo": "Header-module__arFiJq__logo",
  "logoDesktop": "Header-module__arFiJq__logoDesktop",
  "logoMobile": "Header-module__arFiJq__logoMobile",
  "menu": "Header-module__arFiJq__menu",
  "menuBtnDesktopClose": "Header-module__arFiJq__menuBtnDesktopClose",
  "menuCloseBtn": "Header-module__arFiJq__menuCloseBtn",
  "menuContainer": "Header-module__arFiJq__menuContainer",
  "menuHidden": "Header-module__arFiJq__menuHidden",
  "menuVisible": "Header-module__arFiJq__menuVisible",
  "menuWrapper": "Header-module__arFiJq__menuWrapper",
  "mobileMenuTitle": "Header-module__arFiJq__mobileMenuTitle",
  "spacing--lg": "Header-module__arFiJq__spacing--lg",
  "spacing--md": "Header-module__arFiJq__spacing--md",
  "spacing--sm": "Header-module__arFiJq__spacing--sm",
  "spacing--xl": "Header-module__arFiJq__spacing--xl",
  "spacing--xs": "Header-module__arFiJq__spacing--xs",
  "spacing--xxl": "Header-module__arFiJq__spacing--xxl",
  "spacing--xxs": "Header-module__arFiJq__spacing--xxs",
  "spacing--xxxl": "Header-module__arFiJq__spacing--xxxl",
  "spacing--xxxs": "Header-module__arFiJq__spacing--xxxs",
});
